import { useState } from "react";
import "./App.css";

// Content translations
const content = {
  id: {
    nav: { home: "Beranda", about: "Tentang Kami", services: "Layanan", product: "Produk", contact: "Kontak" },
    hero: {
      title: "CV. Indah Sentosa Ban",
      desc: "Kami adalah perusahaan pengolahan ban bekas yang berfokus pada ban kawat truck, diolah menjadi rubber granule untuk kebutuhan industri.",
      cta1: "Hubungi Kami",
      cta2: "Pelajari Lebih Lanjut"
    },
    about: {
      label: "TENTANG KAMI",
      title: "Mitra Terpercaya dalam Pengolahan Ban Kawat",
      p1: "CV. Indah Sentosa Ban adalah perusahaan yang bergerak di bidang pengolahan ban bekas, khususnya ban kawat truck. Ban yang dikumpulkan diproses menjadi rubber granule untuk memenuhi kebutuhan industri.",
      p2: "Kami berkomitmen memberikan proses yang profesional, sistem kerja yang jelas, serta hubungan kerja sama yang baik dengan supplier dan mitra.",
      location: "Lokasi pabrik kami berada di Mojokerto, Indonesia."
    },
    services: {
      label: "LAYANAN KAMI",
      title: "Solusi Lengkap Pengolahan Ban",
      items: [
        { title: "Pembelian Ban Kawat Truck", desc: "Kami menerima pembelian ban kawat truck dari supplier atau pengepul dengan harga yang bersaing." },
        { title: "Pengolahan Rubber Granule", desc: "Ban bekas diproses menjadi rubber granule untuk kebutuhan industri." },
        { title: "Dukungan Kebutuhan Ekspor", desc: "Produk dipersiapkan untuk memenuhi kebutuhan pasar internasional." }
      ]
    },
    product: {
      label: "PRODUK KAMI",
      title: "Rubber Granule",
      desc: "Hasil pengolahan ban bekas yang dapat digunakan untuk berbagai kebutuhan industri.",
      features: ["Fokus pada ban kawat truck", "Harga bersaing"]
    },
    advantages: {
      label: "KEUNGGULAN",
      title: "Mengapa Memilih Kami",
      items: ["Fokus pada ban kawat truck", "Harga bersaing", "Proses profesional", "Respon cepat", "Berbasis manufaktur"]
    },
    contact: {
      label: "KONTAK",
      title: "Hubungi Kami",
      whatsapp: "Chat via WhatsApp"
    },
    footer: "All rights reserved."
  },
  en: {
    nav: { home: "Home", about: "About", services: "Services", product: "Product", contact: "Contact" },
    hero: {
      title: "CV. Indah Sentosa Ban",
      desc: "We are a manufacturing company focused on purchasing used truck tires and processing them into rubber granules for industrial use.",
      cta1: "Contact Us",
      cta2: "Learn More"
    },
    about: {
      label: "ABOUT US",
      title: "Trusted Partner in Tire Processing",
      p1: "CV. Indah Sentosa Ban is a manufacturing company engaged in processing used truck tires. The collected materials are processed into rubber granules for industrial applications.",
      p2: "We are committed to professional operations, clear processes, and reliable partnerships.",
      location: "Our factory is located in Mojokerto, Indonesia."
    },
    services: {
      label: "OUR SERVICES",
      title: "Complete Tire Processing Solutions",
      items: [
        { title: "Used Truck Tire Purchasing", desc: "We accept used truck tires (wire tires) from suppliers at competitive pricing." },
        { title: "Rubber Granule Processing", desc: "Used tires are processed into rubber granules for industrial use." },
        { title: "Export-Oriented Supply", desc: "Products are prepared to meet international market demand." }
      ]
    },
    product: {
      label: "OUR PRODUCT",
      title: "Rubber Granule",
      desc: "Processed material from used tires suitable for various industrial applications.",
      features: ["Focus on truck wire tires", "Competitive pricing"]
    },
    advantages: {
      label: "ADVANTAGES",
      title: "Why Choose Us",
      items: ["Focus on truck wire tires", "Competitive pricing", "Professional process", "Fast response", "Manufacturing-based operation"]
    },
    contact: {
      label: "CONTACT",
      title: "Get in Touch",
      whatsapp: "Chat via WhatsApp"
    },
    footer: "All rights reserved."
  }
};

// Icons as simple SVG components
const Icons = {
  Truck: () => (
    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0" />
    </svg>
  ),
  Settings: () => (
    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Globe: () => (
    <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  MapPin: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Phone: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
    </svg>
  ),
  Mail: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
    </svg>
  ),
  Check: () => (
    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
    </svg>
  ),
  Menu: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
    </svg>
  ),
  X: () => (
    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),
  ChevronDown: () => (
    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  ),
  WhatsApp: () => (
    <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
    </svg>
  ),
  Package: () => (
    <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
    </svg>
  )
};

// WhatsApp link
const whatsappLink = "https://wa.me/6282141137787?text=" + encodeURIComponent("Halo, saya tertarik dengan layanan CV. Indah Sentosa Ban.");

function App() {
  const [lang, setLang] = useState("id");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const t = content[lang];

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };

  const serviceIcons = [Icons.Truck, Icons.Settings, Icons.Globe];

  return (
    <div className="min-h-screen bg-white">
      {/* Navbar */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200">
        <nav className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            <span className="font-bold text-lg text-slate-900">CV. Indah Sentosa Ban</span>
            
            {/* Desktop Nav */}
            <div className="hidden md:flex items-center gap-6">
              {["home", "about", "services", "product", "contact"].map((item) => (
                <button key={item} onClick={() => scrollTo(item)} className="text-sm text-slate-600 hover:text-blue-600 transition-colors">
                  {t.nav[item]}
                </button>
              ))}
              <button onClick={() => setLang(lang === "id" ? "en" : "id")} className="px-3 py-1.5 text-sm font-medium border border-slate-300 rounded hover:bg-slate-50">
                {lang === "id" ? "EN" : "ID"}
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="flex md:hidden items-center gap-2">
              <button onClick={() => setLang(lang === "id" ? "en" : "id")} className="px-2 py-1 text-sm font-medium border border-slate-300 rounded">
                {lang === "id" ? "EN" : "ID"}
              </button>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="p-2">
                {mobileMenuOpen ? <Icons.X /> : <Icons.Menu />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden border-t border-slate-200 py-4">
              {["home", "about", "services", "product", "contact"].map((item) => (
                <button key={item} onClick={() => scrollTo(item)} className="block w-full text-left px-4 py-3 text-slate-700 hover:bg-slate-50">
                  {t.nav[item]}
                </button>
              ))}
            </div>
          )}
        </nav>
      </header>

      {/* Hero Section */}
      <section id="home" className="min-h-screen flex items-center justify-center bg-slate-900 pt-16">
        <div className="max-w-3xl mx-auto px-6 py-20 text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mb-6">{t.hero.title}</h1>
          <p className="text-lg text-slate-300 mb-10 max-w-2xl mx-auto">{t.hero.desc}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button onClick={() => scrollTo("contact")} className="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded transition-colors">
              {t.hero.cta1}
            </button>
            <button onClick={() => scrollTo("about")} className="px-8 py-3 border border-slate-500 text-white hover:bg-slate-800 font-semibold rounded transition-colors">
              {t.hero.cta2}
            </button>
          </div>
          <button onClick={() => scrollTo("about")} className="mt-16 text-white/60 hover:text-white animate-bounce">
            <Icons.ChevronDown />
          </button>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-sm text-blue-600 uppercase font-semibold tracking-wide">{t.about.label}</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mt-4 mb-8">{t.about.title}</h2>
          <p className="text-slate-600 mb-4">{t.about.p1}</p>
          <p className="text-slate-600 mb-8">{t.about.p2}</p>
          <div className="flex items-center justify-center gap-2 text-slate-700">
            <div className="w-10 h-10 bg-blue-50 rounded flex items-center justify-center text-blue-600">
              <Icons.MapPin />
            </div>
            <span className="font-medium">{t.about.location}</span>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="py-20 px-6 bg-slate-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-sm text-blue-600 uppercase font-semibold tracking-wide">{t.services.label}</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mt-4">{t.services.title}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {t.services.items.map((item, i) => {
              const Icon = serviceIcons[i];
              return (
                <div key={i} className="bg-white p-8 border border-slate-200 hover:-translate-y-1 transition-transform">
                  <div className="w-14 h-14 bg-blue-50 rounded flex items-center justify-center text-blue-600 mb-6">
                    <Icon />
                  </div>
                  <h3 className="text-xl font-bold text-slate-800 mb-3">{item.title}</h3>
                  <p className="text-slate-600">{item.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Product Section */}
      <section id="product" className="py-20 px-6 bg-white">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-sm text-blue-600 uppercase font-semibold tracking-wide">{t.product.label}</span>
          <div className="w-20 h-20 bg-slate-900 rounded flex items-center justify-center text-white mx-auto mt-6 mb-6">
            <Icons.Package />
          </div>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mb-6">{t.product.title}</h2>
          <p className="text-slate-600 mb-8">{t.product.desc}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            {t.product.features.map((feature, i) => (
              <div key={i} className="bg-slate-50 px-6 py-4 border-l-2 border-blue-600">
                <span className="text-sm font-semibold text-slate-800">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Advantages Section */}
      <section className="py-20 px-6 bg-slate-900">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-sm text-blue-400 uppercase font-semibold tracking-wide">{t.advantages.label}</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mt-4">{t.advantages.title}</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
            {t.advantages.items.map((item, i) => (
              <div key={i} className="bg-slate-800/50 border border-slate-700 p-6 text-center hover:bg-slate-800 transition-colors">
                <div className="w-12 h-12 bg-blue-600/20 rounded flex items-center justify-center text-blue-400 mx-auto mb-4">
                  <Icons.Check />
                </div>
                <p className="text-slate-200 text-sm font-medium">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-20 px-6 bg-slate-50">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-sm text-blue-600 uppercase font-semibold tracking-wide">{t.contact.label}</span>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-slate-900 mt-4">{t.contact.title}</h2>
          </div>
          <div className="bg-white p-8 border border-slate-200 max-w-lg mx-auto">
            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded flex items-center justify-center text-blue-600">
                  <Icons.MapPin />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800">CV. Indah Sentosa Ban</h3>
                  <p className="text-slate-600">Mojokerto, Indonesia</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded flex items-center justify-center text-blue-600">
                  <Icons.Mail />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800">Email</h3>
                  <a href="mailto:export@indahsentosaban.com" className="text-slate-600 hover:text-blue-600">export@indahsentosaban.com</a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-50 rounded flex items-center justify-center text-blue-600">
                  <Icons.Phone />
                </div>
                <div>
                  <h3 className="font-semibold text-slate-800">WhatsApp</h3>
                  <p className="text-slate-600">+62 821-4113-7787 (Vincent)</p>
                </div>
              </div>
            </div>
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="mt-8 w-full flex items-center justify-center gap-2 px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-semibold rounded transition-colors">
              <Icons.WhatsApp />
              {t.contact.whatsapp}
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-6 bg-slate-900 text-center">
        <p className="text-slate-400 text-sm">© 2026 CV. Indah Sentosa Ban. {t.footer}</p>
      </footer>

      {/* Floating WhatsApp Button */}
      <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform">
        <Icons.WhatsApp />
      </a>
    </div>
  );
}

export default App;
